import React, { Dispatch, SetStateAction, useContext } from "react";
import Typography from "../../ui/widgets/typography";
import { useMessageSource } from "react-message-source";
import ApplicationAPI from "../../api/commercial/application";
import { CardApplicationDocument } from "../../api/commercial/generated-types";
import { ErrorContext } from "../../route/error/provider";
import Dialog from "../../ui/widgets/dialog";
import IconButton from "../../ui/widgets/button-icon";
import Button from "../../ui/widgets/button";
import { ProductContext } from "../../context/product-context/productContext";

// noinspection JSClassNamingConvention
interface ContinueWithoutUploadingModalProps {
  isModalOpen: boolean;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  applicationRef: CardApplicationDocument["applicationRef"];
  triggerReload: () => void;
}

export const ContinueWithoutUploadingModal = ({
  isModalOpen,
  setIsModalOpen,
  applicationRef,
  triggerReload,
}: ContinueWithoutUploadingModalProps): React.JSX.Element => {
  const { getMessage } = useMessageSource();
  const { setError } = useContext(ErrorContext);
  const { selectedProduct } = useContext(ProductContext);

  const onNext = async (): Promise<void> => {
    try {
      await ApplicationAPI.completeCardApplication(
        applicationRef,
        selectedProduct.productRef,
      );
    } catch (e) {
      setError(e);
    }
    triggerReload();
  };

  return (
    <Dialog open={isModalOpen}>
      <div className="scd-dialog-header">
        <Typography variant="h2">
          {getMessage("DocumentUpload.modal.continue-without-uploading.title")}
        </Typography>
        <IconButton
          onClick={() => setIsModalOpen(!isModalOpen)}
          title="Close"
          icon="close"
        />
      </div>
      <Typography variant="body1">
        {getMessage(
          "DocumentUpload.modal.continue-without-uploading.paragraph",
        )}
      </Typography>
      <div className="scd-dialog-footer">
        <Button onClick={() => setIsModalOpen(!isModalOpen)} kind="secondary">
          {getMessage("Onboarding.back")}
        </Button>
        <Button onClick={onNext} kind="primary">
          {getMessage("Onboarding.continue")}
        </Button>
      </div>
    </Dialog>
  );
};
